$(document).ready(function () {
    setUtmSource();

    if (window.innerWidth <= 1500) {
        $('.popcorn__wrapper').slick({
            slidesToShow: 4,
            variableWidth: true,
            centerPadding: '120px',
            prevArrow: false,
            infinite: true,
            nextArrow: false,
            customPaging: function (slider, i) {
                return '<div class="popcorn__index ' + i + '"></div>';
            },
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        dots: true,
                        centerMode: true,
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        dots: true
                    }
                }
            ]
        });
    }

});

// getPopcornCards();
